/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowLeftFromLineIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m6.438 18.938 8.5-8c.624-.563 1.562-.563 2.124.062s.563 1.563-.062 2.125L11.25 18.5H24.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5H11.25L17 26.938c.625.562.625 1.5.063 2.125s-1.5.625-2.125.062l-8.5-8C6.125 20.813 6 20.438 6 20c0-.375.125-.75.438-1.062M31 30.5v-21c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5v21c0 .875-.687 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5"/>}
        </IconWrapper>);
}
